import { ChangeDetectionStrategy, Component, OnDestroy, inject } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { Router } from '@angular/router'
import {
  DataContextBuilder,
  ElderBasicPaneLayoutComponent,
  ElderDataToolbarComponent,
  ElderPaneComponent,
  ElderTableComponent,
  ElderTableToolbarDirective,
  I18nPickPipe,
  IDataContext,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { ProductionListConf } from '../production-list-conf'
import { ProductionListConfService } from '../production-list-conf.service'

import { MatChip, MatChipSet } from '@angular/material/chips'
import { MatSort } from '@angular/material/sort'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'

@Component({
  selector: 'app-production-list-conf-viewer',
  templateUrl: './production-list-conf-viewer.component.html',
  styleUrls: ['./production-list-conf-viewer.component.scss'],
  imports: [
    ElderTableComponent,
    MatSort,
    ElderTableToolbarDirective,
    ElderDataToolbarComponent,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatChipSet,
    MatChip,
    MatIcon,
    ElderTranslatePipe,
    I18nPickPipe,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
  ],
})
export class ProductionListConfViewerComponent implements OnDestroy {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly data: IDataContext<ProductionListConf>
  private router = inject(Router)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const prodListConfService = inject(ProductionListConfService)
    this.data = DataContextBuilder.start<ProductionListConf>()
      .pageSize(20)
      .reloadOnLocalChanges()
      .autoStartAsap()
      .build(prodListConfService)
  }

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnDestroy(): void {
    if (this.data) {
      this.data.close()
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public openDetail(conf: ProductionListConf): void {
    if (conf) {
      this.router.navigate([{ outlets: { side: ['prod-list-conf', conf?.id] } }], {
        preserveFragment: true,
      })
    }
  }

  public createNew(): void {
    this.router.navigate([{ outlets: { side: ['prod-list-conf', 'new'] } }], {
      preserveFragment: true,
    })
  }
}
